import React from 'react';
import s from '../OnboardingPage.module.scss';

export function SecondCustomizationStep({ classNames, changePopupMessage, popupMessage }) {
    return (<><div className="pb-6 pb-lg-14 text-center text-md-left">
        <div className={classNames([s.stepHeader, s.fontWeight600, s.blackFont])}>Welcome your users</div>
    </div>
        <div className="form-group">
            <div style={{
                marginBottom: '1rem',
                width: '510px'
            }} className={classNames([s.mediumTextSize, s.fontWeight500, s.blackFont])}>When a user first visit your store, they will be welcomed with a pop-up message that introduces them into your community (60-80 caracters) </div>
            <textarea style={{
                width: '616px'
            }} onChange={changePopupMessage} className="form-control form-control-solid h-auto p-5 border-0 rounded-lg font-size-h4" id="exampleTextarea" rows="5" defaultValue={popupMessage}></textarea>
        </div></>);
}
